import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=3825f21a&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=js&"
export * from "./table-header.vue?vue&type=script&lang=js&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=3825f21a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825f21a",
  null
  
)

export default component.exports